export default "__VITE_ASSET__CrHjCVTh__"